import React, { useContext } from 'react';
import _isEmpty from 'lodash/isEmpty';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import _get from 'lodash/get';
import Carousel from 'components/ResourcesCarousel';
import ResourceItemSelector from 'components/ResourceItemSelector';
import HeroContext from '../../PageContext';

const useStyles = makeStyles(theme => ({
  item: {
    maxWidth: 232,
    [theme.breakpoints.down('md')]: {
      maxWidth: 190,
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '100%',
    },
  },
  carouselContainer: {
    paddingLeft: '0 !important',
    paddingRight: '0 !important',
    position: 'relative',
    maxWidth: '100vw',
  },
}));

function FeaturedResources() {
  const { featuredResources } = useContext(HeroContext);
  const classes = useStyles();
  const resources = _get(featuredResources, '0', []);

  if (_isEmpty(resources)) return null;

  const sm = resources.length === 1 ? 12 : resources.length === 2 ? 6 : 4;

  return (
    <>
      <Hidden xsDown>
        <Grid container spacing={2}>
          {resources.slice(0, 3).map(item => (
            <Grid item xs={12} sm={sm} key={item.slug} className={classes.item}>
              <ResourceItemSelector item={item} />
            </Grid>
          ))}
        </Grid>
      </Hidden>
      <Hidden smUp>
        <div className={classes.carouselContainer}>
          <Carousel
            swipeable
            responsive={{
              mobile: {
                breakpoint: {
                  max: 600,
                  min: 0,
                },
                items: 1,
              },
            }}
            infinite
            slidesToSlide={1}
            small
          >
            {resources.map(item => (
              <ResourceItemSelector item={item} key={item.slug} />
            ))}
          </Carousel>
        </div>
      </Hidden>
    </>
  );
}

export default FeaturedResources;
